import React, { useEffect, useRef, useState } from "react";
import {
  getCurrentDate,
  getCurrentMonthFirstDate,
  getLastDateOfFY,
  minutesToHHMM,
  secondsToTime,
  timeToSeconds,
} from "../../Utilitie";
import { BiSolidReport } from "react-icons/bi";
import axios from "axios";
import Loading from "../../Extra/Loading";
import DownloadExcel from "../../Extra/DownloadExcel";
const tableHead = [
  "Section",
  "Direction",
  "Engg_Demand",
  "Agreed_Demand",

  "Availed",
  "PERCENTAGE(%) OF BLOCK GIVEN AGAINST AGREED DEMAND",
  "PERCENTAGE(%) OF BLOCK GIVEN AGAINST ENGG DEMAND",
];
const types = ["MACHINE", "OTHER", "CORRIDORE", "NON CORRIDORE"];

const SectionWiseBlockForEng = () => {
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());
  const [endDate, setEndDate] = useState(getCurrentDate());
  const tableRef = useRef();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  ///////////////////////////////////////////////////////////////////////////////////////////
  // ///////////////////////////////////Fetch Data//////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////////////////
  const fetchData = async () => {
    setLoading(true);
    const url = `${urlPrefixBlock}getblockdataDateOnly?start=${startDate}&end=${endDate}`;

    try {
      const response = await axios.get(url);
      const result = response.data;

      if (result.status === "ok") {
        const raw = result.data;

        setData(raw);
      }
      setLoading(false);
    } catch (error) {
      console.error("Axios fetch error:", error);
      setError(true);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  //   //////////////////////////////////////////////////////////////////////////////////
  const sectionMap = {};
  data &&
    data.forEach((group) => {
      group.data.forEach((entry) => {
        const sec = entry.section;
        const dir = entry.direction;

        if (!sectionMap[sec]) {
          sectionMap[sec] = new Set();
        }

        sectionMap[sec].add(dir);
      });
    });
  const result = Object.entries(sectionMap).map(([section, dirSet]) => ({
    section,
    direction: Array.from(dirSet),
  }));
  return (
    <div>
      <div className="bg-dark text-white p-1 d-flex justify-content-between align-items-center papaDiv">
        <div>
          <h5 className="text-center">
            {" "}
            <BiSolidReport /> Section Wise Block (Eng)
          </h5>
        </div>
        <div className="d-flex">
          {" "}
          <b>From</b>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className=" me-1"
          />
          <b>To</b>
          <input
            type="date"
            value={endDate}
            max={getCurrentDate()}
            min={startDate}
            onChange={(e) => setEndDate(e.target.value)}
            className=" me-1"
          />
          <button
            className=" ms-1 btn btn-sm btn-outline-light"
            onClick={fetchData}
          >
            {" "}
            Fetch
          </button>
        </div>
      </div>
      <div className="papaDiv" style={{ position: "relative" }}>
        {loading ? (
          <Loading />
        ) : (
          data && (
            <div>
              <div className="table-responsive" style={{ fontSize: "12px" }}>
                <div ref={tableRef} className="m-2">
                  <div className="row">
                    {types.map((type, ind) => {
                      return (
                        <div className="col-md-6 ">
                          <div
                            className="papaDiv m-1 mb-2 p-0"
                            style={{ maxHeight: "700px", overflow: "auto" }}
                          >
                            <table
                              className="table table-hover table-striped  m-0 border "
                              key={ind}
                            >
                              <thead
                                className="table-dark sticky-top"
                                style={{ zIndex: 10 }}
                              >
                                <tr>
                                  <th
                                    colSpan={8}
                                    style={{ fontSize: "15px" }}
                                    className="text-wrap"
                                  >
                                    {type.replace("CORRIDORE", "CORRIDOR")}{" "}
                                    <b style={{ fontSize: "14px" }}>
                                      {" "}
                                      ( from {startDate} to {endDate})
                                    </b>
                                  </th>
                                </tr>
                                <tr>
                                  <th>Sn</th>
                                  {tableHead.map((title, key) => {
                                    return (
                                      <th key={key} className="text-wrap">
                                        {title.replace(/_/g, " ")}
                                      </th>
                                    );
                                  })}
                                </tr>
                              </thead>
                              <tbody>
                                {data.map((obj) => {
                                  if (obj.type === type) {
                                    return obj.data.map((dataObj, i) => (
                                      <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>{dataObj.section}</td>
                                        <td>{dataObj.direction}</td>

                                        <td>
                                          {minutesToHHMM(
                                            dataObj.Engg_Demand / 60,
                                            true
                                          )}
                                        </td>
                                        <td>
                                          {minutesToHHMM(
                                            dataObj.Agreed_Demand / 60,
                                            true
                                          )}
                                        </td>

                                        <td>
                                          {minutesToHHMM(
                                            dataObj.Availed / 60,
                                            true
                                          )}
                                        </td>
                                        <td>
                                          {dataObj.Availed &&
                                          dataObj.Agreed_Demand ? (
                                            <b>
                                              {(
                                                (dataObj.Availed /
                                                  dataObj.Agreed_Demand) *
                                                100
                                              ).toFixed(0)}
                                              %
                                            </b>
                                          ) : (
                                            "-"
                                          )}
                                        </td>
                                        <td>
                                          {dataObj.Availed &&
                                          dataObj.Engg_Demand ? (
                                            <b>
                                              {(
                                                (dataObj.Availed /
                                                  dataObj.Engg_Demand) *
                                                100
                                              ).toFixed(0)}
                                              %
                                            </b>
                                          ) : (
                                            "-"
                                          )}
                                        </td>
                                      </tr>
                                    ));
                                  } else {
                                    return null;
                                  }
                                })}
                              </tbody>
                              <tfoot
                                className="  table-dark sticky-bottom"
                                style={{ zIndex: 10 }}
                              >
                                <tr>
                                  <td> total</td>
                                  <td colSpan={2}></td>
                                  <td>
                                    {secondsToTime(
                                      data
                                        .filter((obj) => obj.type === type)
                                        .reduce((sum, obj) => {
                                          return (
                                            sum +
                                            obj.data.reduce(
                                              (innerSum, item) =>
                                                innerSum +
                                                (item.Engg_Demand || 0),
                                              0
                                            )
                                          );
                                        }, 0)
                                    )}
                                  </td>
                                  <td>
                                    {secondsToTime(
                                      data
                                        .filter((obj) => obj.type === type)
                                        .reduce((sum, obj) => {
                                          return (
                                            sum +
                                            obj.data.reduce(
                                              (innerSum, item) =>
                                                innerSum +
                                                (item.Agreed_Demand || 0),
                                              0
                                            )
                                          );
                                        }, 0)
                                    )}
                                  </td>
                                  <td>
                                    {secondsToTime(
                                      data
                                        .filter((obj) => obj.type === type)
                                        .reduce((sum, obj) => {
                                          return (
                                            sum +
                                            obj.data.reduce(
                                              (innerSum, item) =>
                                                innerSum + (item.Availed || 0),
                                              0
                                            )
                                          );
                                        }, 0)
                                    )}
                                  </td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="m-1"></div>
                {!data ? (
                  <b style={{ color: "red", fontSize: "14px" }}>
                    Data not found!
                  </b>
                ) : null}
                <DownloadExcel
                  tableRef={tableRef}
                  fileName={`Section Wise Block (Eng) - ${startDate}-${endDate}`}
                />
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};
export default SectionWiseBlockForEng;
